"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MortgageTab = void 0;
var MortgageTab;
(function (MortgageTab) {
    MortgageTab[MortgageTab["OVERVIEW"] = 0] = "OVERVIEW";
    MortgageTab[MortgageTab["SCHEDULE"] = 1] = "SCHEDULE";
    MortgageTab[MortgageTab["RATETABLE"] = 2] = "RATETABLE";
})(MortgageTab = exports.MortgageTab || (exports.MortgageTab = {}));
